import cn from 'classnames';
import React, { FC, ReactNode, memo } from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import TooltipMUI, {
  TooltipProps as TooltipPropsMui,
} from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import useStyles from './styles.module';

type Placement =
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';

export interface TooltipProps {
  title?: string | ReactNode;
  children?: ReactNode;
  placement?: Placement;
  className?: string;
  classNameWrap?: string;
  isInfo?: boolean;
}

const CustomWidthTooltip: FC<TooltipPropsMui> = ({ className, ...props }) => (
  <TooltipMUI classes={{ popper: className }} {...props} />
);

const Tooltip: FC<TooltipProps> = ({
  title = '',
  children,
  placement = 'top-start',
  className = '',
  classNameWrap = '',
  isInfo = false,
  ...props
}) => {
  const { classes, cx } = useStyles();

  return (
    <CustomWidthTooltip
      title={
        title && (
          <Typography
            variant="caption1"
            color={(theme) => theme.palette.custom.text.light}
          >
            {title}
          </Typography>
        )
      }
      placement={placement}
      className={cx(classes.tooltip, classNameWrap)}
      {...props}
    >
      <span className={cn(classes.wrap, className)}>
        {isInfo ? (
          <>
            {children}
            <HelpOutlineIcon className={classes.tooltipIcon} />
          </>
        ) : (
          children
        )}
      </span>
    </CustomWidthTooltip>
  );
};

export default memo(Tooltip);
